import api from "@/lib/api";

export async function getRole(token) {

  const { data } = await api.get("/secretaria-digital/role", {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  
  return data;
}
